<template>
    <v-container fluid>
        <v-layout>
            <v-flex text-xs-center>
                <div class="app-name">Bitacorapp Ronda</div>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex text-xs-center>
                <img src="img/logo-medium.png" class="logo" alt="">
            </v-flex>
        </v-layout>
        <v-layout wrap>
            <v-flex xs12>
                <v-text-field name="username" label="Usuario" v-model="credentials.username" single-line>
                </v-text-field>
            </v-flex>
            <v-flex xs12 wrap>
                <v-text-field name="password" label="Clave" v-model="credentials.password" single-line type="password">
                </v-text-field>
            </v-flex>
        </v-layout>
        <v-layout row wrap justify-end>
            <v-flex text-xs-right>
                <v-btn :color="colorConfirm" class="white--text" block @click="login">Iniciar Sesión</v-btn>
            </v-flex>
        </v-layout>
        
    </v-container>
</template>
<script>
    import { mapActions } from 'vuex';
    export default {
        name: 'login',
        data: () => ({
            credentials: {
                username: '',
                password: '',
            }
        }),
        methods: {
            ...mapActions(['logout']),
            async login() {

                if(!this.credentials.username || !this.credentials.password) return toastr.error('Debe especificar las credenciales');

                const user = await this.$store.dispatch('login', { ...this.credentials });

                if(user) {
                    this.$store.dispatch('getChecklistAnswers');
                    this.$store.dispatch('getRounds', { user: user.id });
                    this.$router.push({ name: 'home' });
                } else {
                    this.logout();
                    this.$router.push({ name: 'login' });
                }
            }
        }
    };

</script>
<style scoped>
    .app-name {
        font-family: Helvetica Neue,Helvetica,Arial,sans-serif;
        font-size: 3rem;
        color: #202761;
        margin-top: 100px;
    }
    .logo {
        max-width: 35%;
        margin-top: 10px;
    }
</style>
